import React from 'react';
import GLink from 'src/components/GLink';
import JoinNowSection from 'src/components/global/JoinNowSection';
import ExploreProducts from 'src/components/global/ExploreProducts';
import HeroSection from 'src/components/global/HeroSection';

const GunbotView = () => {
  return (
    <>
      <HeroSection pageTitle={'Gunbot'} uris={['Products', 'Gunbot']} />

      <div className="page-content">
        <section style={{ backgroundColor: 'rgba(255, 215, 37, 0.02)' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <iframe
                  title="Gunbot"
                  src="https://demo.gunthy.org:8443/chart?pair=USD-BTC&exchange=dydx"
                  height="600"
                  loading="lazy"
                ></iframe>
                <div>
                  <GLink href="#" className="text-body">
                    <i className="bi bi-calendar3 me-1"></i> 3 Nov, 2022
                  </GLink>
                </div>
                <h2 className="my-3">
                  Experience <span className="text-gradient fw-700">Emotionless</span> Trading With
                  <span className="text-gradient fw-700">Gunbot</span>
                </h2>
                <p className="mb-4 lead">
                  The difference between manual trading and trading with Gunbot are your emotions. Trade 24/7, increase
                  your profits and don't let your emotions trade for you.
                </p>

                <div className="mb-4">
                  <h5>Trade on Every Available Crypto Exchange</h5>
                  <p className="mb-0">
                    Partner Exchanges are Official Gunbot Partners. We are in direct contact with their teams: Binance,
                    Huobi,OKx,Beaxy,Bybit,KuCoin,Kraken,HitBTC,MEXC,Bitget. Certified Exchanges have been Supported
                    in Gunbot for a long time, Tested High-Quality API support: Poloniex, Bittrex,
                    Bitfinex,BitMex,Cex,Coinbase. Plus More Than 100 EXCHANGES and New Ones Added as they Become
                    Available in the CCXT Library
                  </p>
                </div>
                <div className="mb-5">
                  <h5>Gunbot Features</h5>
                  <p className="mb-0">
                    Gunbot allows you to fully automate your crypto trading. Using community-developed strategies even
                    beginning traders can take advantage of the opportunities in the volatile crypto markets. For expert
                    traders, Gunbot is perfect to execute custom strategies on a large number of trading pairs or to
                    automate certain parts of trading – like selling with a trailing stop or averaging down. Support
                    automated trading on spot and margin exchanges. You can use both trends following as mean reversal
                    based strategies. Full customization possible by executing trades through TradingView alerts. Unlike
                    other tools, Gunbot is not a subscription service and charges zero markup on trades. We’re as
                    privacy friendly as it gets: your trading data stays between you and your exchange, no API secrets
                    are centrally saved and nothing gets shared with third parties.
                  </p>
                </div>
                <blockquote
                  className="blockquote border-start border-primary p-5 text-white mb-5"
                  style={{ backgroundColor: 'rgba(30, 80, 255, 0.02)' }}
                >
                  <p>
                    The real value is not money, it is how many time you spend and how much attention you pay in what
                    you are doing: spend time and pay attention to your trading strategies, you will get excellent
                    results.
                  </p>
                  <div className="blockquote-footer text-primary mt-2">Gunthar De Niro</div>
                </blockquote>

                <div className="mb-4">
                  <h5>Gunbot From Beginning to End</h5>
                  <ul className="list-unstyled">
                    <li className="d-flex mb-2">
                      <i className="bi bi-dot me-2"></i> Gunbot is a locally installed software to automatically trade
                      on the most popular exchanges for cryptocurrencies. It runs on Windows, macOS, Linux, and even on
                      a Raspberry Pi.
                    </li>
                    <li className="d-flex mb-2">
                      <i className="bi bi-dot me-2"></i> You select the coins to automatically trade. Gunbot will
                      monitor the market and trade on your behalf. Day and night, catching every opportunity.
                    </li>
                    <li className="d-flex mb-2">
                      <i className="bi bi-dot me-2"></i> Choose from many tested trading strategies presets, or create
                      and backtest your individual strategy. You decide, Gunbot executes.
                    </li>
                    <li className="d-flex">
                      <i className="bi bi-dot me-2"></i> Beginning trader? No problem! Gunbot is built for newcomers as
                      well as power users. We'll help you get started.
                    </li>
                  </ul>
                </div>
                <div className="d-md-flex justify-content-between border-top border-bottom border-dark py-4">
                  <div className="d-flex align-items-center">
                    <h6 className="mb-0 me-4">Share It:</h6>
                    <div className="social-icons">
                      <ul className="list-inline mb-0">
                        <li>
                          <GLink href="#">
                            <i className="bi bi-facebook"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-dribbble"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-instagram"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-twitter"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-linkedin"></i>
                          </GLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="d-flex align-items-center text-md-end mt-5 mt-md-0">
                    <h6 className="mb-0 me-4">Tags:</h6>
                    <ul className="list-inline mb-0 widget-tags">
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Bitcoin
                        </GLink>
                      </li>
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Trading
                        </GLink>
                      </li>
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Binance
                        </GLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ExploreProducts />

        <JoinNowSection />
      </div>
    </>
  );
};

export default GunbotView;
